<template>
  <div class="brand-list">
    <el-card>
      <div slot="header" class="card-header">
        <span>品牌管理</span>
        <el-button type="primary" size="small" @click="handleAdd">新增品牌</el-button>
      </div>
      <el-table :data="tableData" border stripe style="cursor: pointer;">
        <el-table-column prop="uid" label="UID" width="120"></el-table-column>
        <el-table-column prop="nameCn" label="中文名" width="120"></el-table-column>
        <el-table-column prop="fullName" label="全名"></el-table-column>
        <el-table-column prop="shortName" label="简称" width="100"></el-table-column>
        <el-table-column prop="logo" label="Logo" width="100">
          <template slot-scope="scope">
            <img v-if="scope.row.logo" :src="getImageUrl(scope.row.logo)" style="width: 50px; height: 50px; object-fit: contain;">
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click.stop="handleViewProducts(scope.row)">查看商品</el-button>
            <el-button type="text" size="small" @click.stop="handleEdit(scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px">
      <el-form :model="form" :rules="rules" ref="form" label-width="80px">
        <el-form-item label="中文名" prop="nameCn">
          <el-input v-model="form.nameCn" placeholder="请输入中文名"></el-input>
        </el-form-item>
        <el-form-item label="全名" prop="fullName">
          <el-input v-model="form.fullName" placeholder="请输入全名"></el-input>
        </el-form-item>
        <el-form-item label="简称" prop="shortName">
          <el-input v-model="form.shortName" placeholder="请输入简称"></el-input>
        </el-form-item>
        <el-form-item label="Logo" prop="logo">
          <el-input v-model="form.logo" placeholder="请输入Logo URL"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getImageUrl } from '@/utils/image'

export default {
  name: 'BrandList',
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      dialogTitle: '',
      form: {
        uid: null,
        nameCn: '',
        fullName: '',
        shortName: '',
        logo: ''
      },
      rules: {
        nameCn: [{ required: true, message: '请输入中文名', trigger: 'blur' }]
      },
      submitLoading: false
    }
  },
  async mounted() {
    await this.loadData()
  },
  methods: {
    getImageUrl,
    async loadData() {
      try {
        const res = await this.$http.get('/brand/list')
        if (res.code === '200') {
          this.tableData = res.data || []
        }
      } catch (error) {
        this.$message.error('加载数据失败')
      }
    },
    handleAdd() {
      this.dialogTitle = '新增品牌'
      this.form = { uid: null, nameCn: '', fullName: '', shortName: '', logo: '' }
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.dialogTitle = '编辑品牌'
      this.form = { 
        uid: row.uid,
        nameCn: row.nameCn,
        fullName: row.fullName,
        shortName: row.shortName,
        logo: row.logo
      }
      this.dialogVisible = true
    },
    handleViewProducts(row) {
      this.$router.push({
        name: 'Product',
        query: { brandUid: row.uid, brandName: row.nameCn }
      })
    },
    async handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.submitLoading = true
          try {
            const url = this.form.uid ? '/brand/update' : '/brand/add'
            const res = await this.$http.post(url, this.form)
            if (res.code === '200') {
              this.$message.success('操作成功')
              this.dialogVisible = false
              await this.loadData()
            } else {
              this.$message.error(res.msg || '操作失败')
            }
          } catch (error) {
            this.$message.error('操作失败')
          } finally {
            this.submitLoading = false
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
